<template>
  <div class="admin-diary-edit">
    <div class="main" v-bind:class="{ dark: darkmode }">
      <toolbar 
        :loading=loading 
        :toggle_preview=toggle_preview
        :preview=preview
        :primary_action=save_diary>
      </toolbar>
      <div class="wrap">
        <div class="inputs">
          <div class="col">
            <div class="input"><div class="label">Title</div><input type="text" v-model="diary.title"></div>
            <div class="input"><div class="label">Category</div><input type="text" v-model="diary.category"></div>
            <div class="input"><div class="label">Medium</div><input type="text" v-model="diary.medium"></div>
            <div class="input"><div class="label">Description</div><input type="text" v-model="diary.description"></div>
          </div>
          <div class="input-col">
            <div class="input"><div class="label">Tags</div><input type="text" v-model="diary.tags"></div>
            <div class="input"><div class="label">Links</div><input type="text" v-model="diary.links"></div>
            <div class="input"><div class="label">Image</div><input type="text" v-model="diary.image.key"></div>
            <div class="input"><div class="label">Published?</div><input type="checkbox" v-model="diary.published"></div>
          </div>
        </div>
      </div>
      <div class="editor">
        <div class="page-select">
          <div class="page-label" v-for="(p,i) in diary.content" v-bind:key="p.page+i" v-on:click="switch_page(i)">{{p.page}}</div>
          <div class="bubble" v-on:click="add_page()">+</div>
        </div>
        <div class="page" v-for="(page, page_index) in diary.content" v-bind:key="page_index" v-bind:class="{visible: page_index == selected_page}">
          <div class="page-edit">
            <div class="page-label-edit input"><div class="label">Page Title</div><input type="text" v-model="page.page"></div>
            <div class="remove-page"><button class="red" v-on:click="remove_page(page_index)">Delete Page</button></div>
          </div>
          <div class="section" v-for="(section, index) in page.sections" v-bind:key="index">
            <div class="section-settings">
              <button v-bind:class="{blue: section.type == 'Markdown'}" v-on:click="set_section_type(page_index, index, 'Markdown')">markdown</button>
              <button v-bind:class="{blue: section.type == 'Image'}" v-on:click="set_section_type(page_index, index, 'Image')">image</button>
              <button class="red" v-on:click="remove_section(page_index, index)">remove</button>
            </div>
              <div class="section-edit">
              <div class="half expand">
                <div v-if="section.type == 'Markdown'" >
                  <textarea v-model="section.data"></textarea>
                </div>
                <div v-if="section.type == 'Image'" >
                  <div class="image-select">
                    <div class="input"><input type="text" v-model="section.key">
                      <button class="red" v-on:click="load_image(page_index, index)">update</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="half" v-if="preview">
                <content-section :content="section" v-bind:key=index></content-section>
              </div>
            </div>
          </div>
          <div class="section-add">
            <div class="bubble" v-on:click="add_section(page_index)">+</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContentSection from '../common/Content'
import Toolbar from './Toolbar'
export default {
  components: {
    ContentSection,
    Toolbar
  },
  data: () => {
    return {
      diary: {
        image: {},
        content: []
      },
      selected_page: 0,
      preview: true,
      loading: true,
    }
  },
  methods: {
    switch_page(index) {
      this.selected_page = index
    },
    add_page(name = 'new_page') {
      this.diary.content.push({ sections: [], page: name })
      this.selected_page = this.diary.content.length - 1
    },
    remove_page(index) {
      this.diary.content.splice(index, 1)
      this.selected_page = this.diary.content.length - 1
    },
    add_section(page_index) {
      let section = this.init_section({ type: "Markdown" })
      this.diary.content[page_index].sections.push(section)
    },
    remove_section(page_index, index) {
      this.diary.content[page_index].sections.splice(index, 1)
    },
    set_section_type(page_index, index, type) {
      let section = this.diary.content[page_index].sections[index]
      section.type = type
      Object.assign(this.diary.content[page_index].sections[index], this.init_section(section))
    },
    init_section(section) {
      switch(section.type){
        case "Markdown": return { type: 'Markdown', data: 'sample text' }
        case "Image": return { type: 'Image' }
      }
    },
    init_diary(key) {
      return {
        key: key,
        image: { key: null },
        content: [{
          page: null,
          sections: []
        }],
        preview: true,
        loading: true
      }
    },
    load_image(page_index, index) {
      let section = this.diary.content[page_index].sections[index]
      this.$store.dispatch('fetchImage', section.key).then((data) => {
        this.$set(this.diary.content[page_index].sections[index], 'url', data.image.url)
      })
    },
    toggle_preview() {
      this.preview = !this.preview
      return this.preview
    },
    save_diary() {
      if(this.loading) return;
      this.loading = true
      // TODO: move input transform to server
      let stripped_down_content = this.diary.content.map((page) => { // is this still needed?
        return {
          page: page.page,
          sections: page.sections.map((section) => {
            switch(section.type){
              case "Markdown": return { type: 'markdown', data: section.data }
              case "Image": return { type: 'image', key: section.key }
            }
          })
        }
      })

      let tags = null
      let links = null
      if(typeof this.diary.tags == "string") {
        tags = this.diary.tags.trim().slice(',')
      } else {
        tags = this.diary.tags
      }
      if(typeof this.diary.links == "string") { // TODO: remove links
        links = this.diary.links.trim().slice(',')
      } else {
        links = this.diary.links
      }
      let payload = {
        key: this.diary.key,
        title: this.diary.title,
        description: this.diary.description,
        published: this.diary.published,
        category: this.diary.category,
        links: links,
        tags: tags,
        medium: this.diary.medium,
        image: { key: this.diary.image.key },
        content: stripped_down_content
      }
      this.$store.dispatch('updateDiary', payload).then((res) => {
        console.log('updated!!!')
        this.loading = false
      }, (err) => {
        console.error(err)
      })
    }
  },
  computed: {
    darkmode() {
      return this.$store.state.darkmode
    },
  },
  created: function() {
    this.$store.dispatch('fetchDiary', this.$route.params.key).then(() => {
      this.diary = this.$store.state.diary
      this.loading = false
	  }, () => {
      console.log('new diary entry!')
      this.loading = false
      this.diary = this.init_diary(this.$route.params.key)
    })
  }
}
</script>
